import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { db, doc, getDoc } from "../firebaseConfig";
import "./ScreenPage.css";
import TopBar from "../components/TopBar";
import Footer from "../components/Footer";

function ScreenPage() {
  const { screenId } = useParams();
  const [documents, setDocuments] = useState([]);
  const [error, setError] = useState(null);
  const fetchScreenData = async () => {
    setError(null);

    try {
      const screenRef = doc(db, "screens", screenId);
      const screenSnap = await getDoc(screenRef);

      if (!screenSnap.exists()) {
        throw new Error("Yarışmalara ait belgeniz bulunmamaktadır.");
      }

      const screenData = screenSnap.data();

      if (
        !screenData.documents_ids ||
        !Array.isArray(screenData.documents_ids)
      ) {
        throw new Error("Ekran verisinde geçerli document_ids bulunamadı.");
      }

      const documentPromises = screenData.documents_ids.map(async (docId) => {
        const documentRef = doc(db, "documents", docId);
        const documentSnap = await getDoc(documentRef);

        if (documentSnap.exists()) {
          const documentData = documentSnap.data();

          const documentTypeRef = doc(
            db,
            "document_types",
            documentData.document_type
          );
          const documentTypeSnap = await getDoc(documentTypeRef);

          const documentTypeTitle = documentTypeSnap.exists()
            ? documentTypeSnap.data().title
            : "Belge Türü Bulunamadı";
          const isHidden = documentTypeSnap.exists()
            ? documentTypeSnap.data().is_hidden
            : false;

          return {
            id: docId,
            title: documentTypeTitle,
            is_hidden: isHidden,
            created_at: documentData.created_at,
            ...documentData,
          };
        }
        return null;
      });

      const documentsData = await Promise.all(documentPromises);
      const filteredDocuments = documentsData.filter(
        (doc) => doc && !doc.is_hidden
      );
      
      // Benzersiz belgeleri filtrele
      const uniqueDocuments = filteredDocuments.reduce((acc, current) => {
        const x = acc.find(item => item.id === current.id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      const sortedDocuments = uniqueDocuments.sort(
        (a, b) => b.created_at - a.created_at
      );

      setDocuments(sortedDocuments);
    } catch (error) {
      console.error("Veri alırken hata oluştu:", error.message);
      setError(error.message);
    }
  };
  useEffect(() => {
    fetchScreenData();
  }, [screenId]);

  return (
    <div className="container">
      <TopBar />
      <div className="document-list">
        <h4 className="document-text">Tüm Belgelerim</h4>

        {error && <p className="error-message">{error}</p>}
        
        {documents.map((doc) => (
          <div key={doc.id} className="document-item">
            <h3>{doc.title || "Belge Başlığı"}</h3>
            <p>{doc.season}</p>
            <Link to={`/screens/${screenId}/documents/${doc.id}`}>
              Belgeyi Görüntüle
            </Link>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
}

export default ScreenPage;
